module.exports = __webpack_public_path__ + "static/media/right_black_arrow.7f838f84.svg";